"use client"

import type { AnalyticsProvider, ProviderName } from './types'
import { inscalarProvider } from './providers/inscalar-provider'
import { datadogProvider } from './providers/datadog-provider'
import { env } from 'next-runtime-env'

const providerMap: Record<ProviderName, AnalyticsProvider> = {
  inscalar: inscalarProvider,
  datadog: datadogProvider,
}

function isProviderName(name: string): name is ProviderName {
  return name in providerMap
}

function parseEnabledProviders(): readonly ProviderName[] {
  const envValue = env('NEXT_PUBLIC_ANALYTICS_PROVIDERS') ?? ''

  if (!envValue.trim()) {
    return []
  }

  return envValue
    .split(',')
    .map((name) => name.trim().toLowerCase())
    .filter(isProviderName)
}

const enabledNames = parseEnabledProviders()

export const enabledProviders: readonly AnalyticsProvider[] = enabledNames.map(
  (name) => providerMap[name]
)
